import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';
import TitleSetter from '../components/TitleSetter';
import TopBar from '../components/TopBar';
import '../styles/PaymentSuccess.css';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState(null);
  const [teamLogo, setTeamLogo] = useState('');
  const [teamId, setTeamId] = useState('');
  const [planStatus, setPlanStatus] = useState('pending');
  const [planId, setPlanId] = useState('');
  const [billingCycle, setBillingCycle] = useState('');
  const [statusMessage, setStatusMessage] = useState('Confirming your payment...');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setStatusMessage('Please log in to view your subscription status.');
        return;
      }
      try {
        const userSnap = await getDoc(doc(db, `users/${user.uid}`));
        if (userSnap.exists()) {
          const data = userSnap.data();
          setTeamId(data.teamId || '');
        }
      } catch (error) {
        console.error('Failed to load user team', error);
        setStatusMessage('Unable to load your team. Please refresh.');
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!teamId) return undefined;
    const teamRef = doc(db, `teams/${teamId}`);
    const unsubscribe = onSnapshot(teamRef, (snap) => {
      const data = snap.data() || {};
      const nextStatus = data.planStatus || 'pending';
      setPlanStatus(nextStatus);
      setPlanId(data.planId || '');
      setBillingCycle(data.billingCycle || '');
      if (nextStatus === 'active' || nextStatus === 'trialing') {
        setStatusMessage('Your subscription is active.');
      } else {
        setStatusMessage('We are confirming your payment. This can take a minute.');
      }
    });
    return () => unsubscribe();
  }, [teamId]);

  const isActive = planStatus === 'active' || planStatus === 'trialing';
  const planLabel = planId ? planId.toUpperCase() : 'PLAN';
  const cycleLabel = billingCycle ? billingCycle.toUpperCase() : '';

  return (
    <>
      <TitleSetter title="Payment Success" />
      <div className="container">
        <TopBar
          userProfile={userProfile}
          teamLogo={teamLogo}
          setUserProfile={setUserProfile}
          setTeamLogo={setTeamLogo}
        />

        <div className="payment-success">
          <div className={`payment-card ${isActive ? 'is-active' : ''}`}>
            <h1>Thanks for subscribing</h1>
            <p className="status-text">{statusMessage}</p>

            <div className="status-pill">
              Status: <span>{planStatus || 'pending'}</span>
            </div>

            {(planId || billingCycle) && (
              <div className="plan-row">
                <span>{planLabel}</span>
                {cycleLabel && <span>{cycleLabel}</span>}
              </div>
            )}

            <div className="payment-actions">
              <button className="primary-btn" onClick={() => navigate('/my-strategy')}>
                Go to Strategy
              </button>
              <button className="secondary-btn" onClick={() => navigate('/my-calendar')}>
                Open Calendar
              </button>
            </div>

            {!teamId && (
              <div className="payment-note">
                No team detected. Join or create a team to unlock your subscription.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
